/**
 * Currey & Company display fix (Foundry Lighting)
 * Rewrites "Currey and Company" -> "Currey & Company" in visible page text only.
 * Data (product.vendor, collection handles, feeds, JSON-LD) is untouched.
 *
 * Install: theme.liquid, just before </body>
 *   <script src="{{ 'currey-vendor-rename-v2.js' | asset_url }}" defer></script>
 * or paste inline inside a <script> tag.
 */
(function () {
  var FROM = /Currey\s+and\s+Company/gi;
  // Preserve the casing of the match (cards/labels are often uppercase in the markup)
  function TO(m) { return m === m.toUpperCase() ? 'CURREY & COMPANY' : 'Currey & Company'; }

  // Elements whose text must never be rewritten
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, CODE: 1, PRE: 1 };

  function fixNode(root) {
    if (!root) return;
    if (root.nodeType === 3) { // text node
      if (FROM.test(root.nodeValue)) {
        FROM.lastIndex = 0;
        root.nodeValue = root.nodeValue.replace(FROM, TO);
      }
      FROM.lastIndex = 0;
      return;
    }
    if (root.nodeType !== 1 && root.nodeType !== 11) return;
    if (SKIP[root.nodeName]) return;

    // Common attributes that show the vendor name
    if (root.nodeType === 1) {
      ['alt', 'title', 'aria-label', 'placeholder'].forEach(function (a) {
        var v = root.getAttribute && root.getAttribute(a);
        if (v && FROM.test(v)) { FROM.lastIndex = 0; root.setAttribute(a, v.replace(FROM, TO)); }
        FROM.lastIndex = 0;
      });
    }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        return p && SKIP[p.nodeName] ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var n, nodes = [];
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(fixNode);
  }

  function run() {
    fixNode(document.body);
    if (FROM.test(document.title)) { FROM.lastIndex = 0; document.title = document.title.replace(FROM, TO); }
    FROM.lastIndex = 0;
  }

  // Initial pass
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // Catch content injected later (recommendations, quick view, cart drawer, search results, etc.)
  var queue = [], scheduled = false;
  function flush() {
    scheduled = false;
    var batch = queue; queue = [];
    batch.forEach(fixNode);
  }
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.type === 'characterData') queue.push(m.target);
      else for (var i = 0; i < m.addedNodes.length; i++) queue.push(m.addedNodes[i]);
    });
    if (!scheduled) { scheduled = true; requestAnimationFrame(flush); }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
